import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Input, Spin } from 'antd';
import { getPrintTemplateList } from '@/services'
import { billPrintConfigSavePage, billPrintConfigUpdatePage, esignCommonList } from '@/services/fmsConfig'
import { httpCompanyList, getEnum } from '@/services/fmsServices'
const Option = Select.Option;
// @ts-ignore
export function modalAddOrEditFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest?.id ? '编辑' : '新增'}`,
    width: 500,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
// @ts-ignore
const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [printTemplateLoading, setPrintTemplateLoading] = useState(false);
  const [printTemplateOption, setPrintTemplateOption] = useState([] as any[]);
  const [companyOption, setCompanyOption] = useState([] as any[]);
  const [printTypeList, setPrintTypeList] = useState([] as any[]);

  useEffect(() => {
    initFn();
    loadReceipt();
  }, []);

  const initFn = () => {
    const { printTemplateId, printType, refundPrintTemplateId, nonProjectPrintTemplateId, companyOrgId } = rest;
    // 回显数据
    if (rest?.id) {
      form.setFieldsValue({
        printType,
        printTemplateId,
        refundPrintTemplateId,
        nonProjectPrintTemplateId,
        companyOrgIds: companyOrgId,
      });
    }
  };
  const loadReceipt = async() => {
    setPrintTemplateLoading(true)
    // let orgCompanyList = await esignCommonList() //财务主体
    let orgCompanyList = await httpCompanyList()
    setCompanyOption(orgCompanyList as any[]);
    const printTypeLists:any = await getEnum('com.shj.saas.plus.fms.enums.PrintTypeEnum') //
    setPrintTypeList(printTypeLists)
    if(!rest?.id){
      form.setFieldsValue({
        printType: 'machinePrinting',
      });
    }
    let printTemplateArr = await getPrintTemplateList({ name: '' })
    setPrintTemplateOption(printTemplateArr as any[]);
    setPrintTemplateLoading(false)
  };

  // 重置
  const onReset = () => {
    form.resetFields();
  };
  // 提交
  const onFinish = (values: any) => {
    let newValues = { ...values };
    const { id } = rest;
    setAddOrEditFooterLoading(true);
    if (id) {
      newValues.companyOrgId = newValues.companyOrgIds;
      newValues.id = id;
      delete newValues.companyOrgIds
      billPrintConfigUpdatePage(newValues).then((response: any) => {
        setAddOrEditFooterLoading(false);
        message.info(response?.message || '操作成功');
        onClose();
        fn && fn();
      }).catch(err=>{
        setAddOrEditFooterLoading(false);
      });
    } else {
      billPrintConfigSavePage(newValues).then((response: any) => {
        setAddOrEditFooterLoading(false);
        message.info(response?.message || '操作成功');
        onClose();
        fn && fn();
      }).catch(err=>{
        setAddOrEditFooterLoading(false);
      });
    }
  };
  const filterOption = (input: any, option: any) => {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  return (
    <div style={{padding: '15px'}}>
      <Spin spinning={printTemplateLoading}>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          label="打印方式"
          name="printType"
          {...formItemLayout}
          rules={[{ required: true, message: '请选择打印方式' }]}
        >
          <Select disabled={true} style={{ width: '100%', margin: '-5px 0' }}>
            {printTypeList.map((item) => {
              return (
                <Option key={item.key} value={item.key}>
                  {item.description}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label="打印模板"
          name="printTemplateId"
          {...formItemLayout}
          rules={[{ required: true, message: '请选择打印模板' }]}
        >
          <Select showSearch filterOption={filterOption} style={{ width: '100%', margin: '-5px 0' }}>
            {printTemplateOption.map((item, index) => {
              return (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label="公司"
          name="companyOrgIds"
          {...formItemLayout}
          rules={[{ required: true, message: '请选择公司' }]}
        >
          <Select showSearch mode={!rest.id ? 'multiple' : undefined}  filterOption={filterOption} style={{ width: '100%', margin: '-5px 0' }}>
            {companyOption.map((item, index) => {
              return (
                <Select.Option key={index} value={item.orgId}>
                    {item.companyName}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item style={{marginBottom: 10}}>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'right' }}>
              {/* <Button htmlType="button" onClick={onReset}>
                重置
              </Button> */}
              <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
                取消
              </Button>
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={addOrEditFooterLoading}>
                提交
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
      </Spin>
    </div>
  );
};
